<template>
  <div>
    <van-tabs v-model="active" sticky offset-top="0">
      <van-tab title="全部订单" name="one">
        <OrderItem ref="one" @getOrderList="getOrderList" :list="allOrderList" />
      </van-tab>
      <van-tab title="待支付" name="two">
        <OrderItem ref="two" @getOrderList="getOrderList" :list="paidOrderList" />
      </van-tab>
      <van-tab title="我的拼团" name="three">
        <OrderItem ref="three" @getOrderList="getOrderList" :list="compOrderList" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import OrderItem from '@/components/mine/orderCoupon/order/orderItem'
export default {
  components:{
    OrderItem
  },
  data() {
    return {
      active:"one",
      allOrderList:[],  // 存储全部订单
      paidOrderList:[],  // 存储待支付订单
      compOrderList:[],  // 已完成的订单
      allPageIndex:1,
      paidPageIndex:1,
      comPageIndex:1
    };
  },
  methods: {
    getOrderList(){
      let that = this
      let url = ""
      if(this.active == "one"){
        url = `api/mine/getOrderList?pageIndex=${this.allPageIndex}`
      }else if(this.active == "two"){
        url = `api/mine/getNoPayOrderList?pageIndex=${this.paidPageIndex}`
      }else {
        url = `api/mine/getPinGroupOrderList?pageIndex=${this.comPageIndex}`
      }
      that.Api({
        url:url,
        method:"GET"
      }).then(res => {
        if(this.active == "one"){
          this.allPageIndex += 1
          this.allOrderList = this.allOrderList.concat(res.data.data)
          this.$refs.one.loading = false
          if(this.allOrderList.length + 1 >= res.data.total)
          this.$refs.one.finished = true
        }else if(this.active == "two"){
          this.paidPageIndex += 1
          this.paidOrderList = this.paidOrderList.concat(res.data.data)
          this.$refs.two.loading = false
          if(this.paidOrderList.length + 1 >= res.data.total)
          this.$refs.two.finished = true
        }else {
          this.comPageIndex += 1
          this.compOrderList = this.compOrderList.concat(res.data.data)
          this.$refs.three.loading = false
          if(this.compOrderList.length + 1 >= res.data.total)
          this.$refs.three.finished = true
        }
      })
    }
  },
};
</script>

<style lang="less" scoped></style>
